module.exports = __webpack_public_path__ + "static/media/5DPO12.2375d75b.jpg";